export class LayoutBindingHandler implements KnockoutBindingHandler {
    public init = (element: any, _valueAccessor: () => any, allBindingsAccessor?: KnockoutAllBindingsAccessor) => {
        let allBindings = allBindingsAccessor!();
        let layout = null;
        if (allBindings.layout) {
            layout = ko.unwrap(allBindings.layout);
        }
        if (layout) {
            let regel = ko.unwrap(allBindings.regel);
            if (regel) {
                let itemsOpRegel = [];
                for (let i in layout.Items) {
                    let item = layout.Items[i];
                    if (item.Regelnummer === regel) {
                        itemsOpRegel.push(item);
                    }
                }

                let sortedItems = itemsOpRegel.sort(function (a, b): number {
                    if (a.Volgnummer > b.Volgnummer) {
                        return 1;
                    } else if (a.Volgnummer < b.Volgnummer) {
                        return -1;
                    } else {
                        return 0;
                    }
                });

                for (let i in sortedItems) {
                    let bindingHandler = this.getBindingHandlerForDisplayType(sortedItems[i].DisplayType);
                    if (bindingHandler) {
                        let id = sortedItems[i].Veld || ('"' + sortedItems[i].Label + '"');

                        let span = document.createElement("span");
                        span.setAttribute("data-bind", bindingHandler + ": " + id);
                        element.appendChild(span);
                        if (bindingHandler === "icon") {
                            span.setAttribute("syn-data-type", "icon");
                        }
                    }
                }
            }
        }
    }

    private getBindingHandlerForDisplayType(dataType: string): string {
        if (dataType === "Aantal") {
            return "decimalSeparator: ',', aantal";
        } else if (dataType === "Telefoon") {
            return "telefoon";
        } else if (dataType === "JaNee") {
            return "textJN";
        } else if (dataType === "Icon") {
            return "icon";
        } else if (dataType === "DatumTijd") {
            return "date";
        } else if (dataType === "Datum") {
            return "dateformat: 'date', date";
        } else if (dataType === "DatumKortJaar") {
            return "dateformat: 'dateShortYear', date";
        } else if (dataType === "Tijd") {
            return "dateformat: 'shorttime', date";
        } else if (dataType === "TijdKort") {
            return "dateformat: 'shorttimeWithDesc', date";
        } else {
            return "text";
        }
    }
}
